export enum ThirdAuthSource {
  EXTERNAL_SOCIAL = 'EXTERNAL_SOCIAL',
  EXTERNAL_WALLET = 'EXTERNAL_WALLET',
}
